import YandexDiscInput from './yandex-disc-input';

export default YandexDiscInput;
